import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Profil } from 'app/shared/models/profil.model';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfileService {
    private httpClient = inject(HttpClient);

    accountUrl = environment.ENDPOINTS.ACCOUNT_URL;
    registerUrl = environment.ENDPOINTS.REGISTER_URL;
    GuestRegisterUrl = environment.ENDPOINTS.GUEST_REGISTER_URL;
    recaptchatUrl = environment.ENDPOINTS.RECAPTCHA_KEY_URL;



    /**
     * Constructor
     *
     * @param httpClient http client
     */
    constructor() {

    }

    /**
     * get the profil of the connected user
     */
    getProfil(): Observable<any> {
        const req = this.accountUrl;
        return this.httpClient.get<any>(req);
    }

    /**
     * edit the profil user
     * @param profile the edited profil
     */
    updateProfil(profile): Observable<any> {
        const req = this.accountUrl;
        return this.httpClient.post<any>(req, profile);
    }

    /**
     * register a profil
     * @param profile the profil to create
     */
    registerAccount(profile: Profil, resp: any): Observable<any> {
        console.log(resp);

        const req = this.registerUrl + `?response=${resp}&applicationType=RH_PARTNER`;
        return this.httpClient.post<any>(req, profile);
    }
    /**
     * 
     * @param profile profile ti register
     */
    registerGuest(profile: any): Observable<any> {
        const req = this.GuestRegisterUrl + '?applicationType=RH_PARTNER';
        return this.httpClient.post<any>(req, profile);
    }

    /**
     * upload an image profil
     * @param image the image to set
     */
    uploadImage(image: File): Observable<any> {
        const req = this.accountUrl + '/profile-image';
        const uploadData = new FormData();
        uploadData.append('image', image, image.name);
        return this.httpClient.post(req, uploadData);
    }

    getGoogleRecaptchaKeySite(): Observable<any> {
        const req = this.recaptchatUrl;
        return this.httpClient.get<any>(req);
    }
}
